module.exports = __webpack_public_path__ + "static/media/moreOutlined.bbd0f902.svg";